import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.number.isRequired,
  body: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  profileUrl: PropTypes.string,
  publishedAt: PropTypes.string.isRequired,
  removable: PropTypes.bool.isRequired,
};

const defaultProps = {
  profilePictureUrl: null,
  profileUrl: null,
};

export { propTypes, defaultProps };
